module.exports = __webpack_public_path__ + "img/frame-customize-icon.d12dc06d.svg";